/* eslint-disable no-var */
/********************************************************
 * API MODULE
 *
 * directly handles server api calls
 *
 ********************************************************/

/**********************************************
 DEPENDENCIES
**********************************************/

var $ = require('jquery');
var ds = require('Modules/data_store');
var utils = require('Utilities/utils');

/**********************************************
 VARIABLE DECLARATION
**********************************************/

var self = {};
var options;
var headers = {};

var default_args = {
    forbidden: error_forbidden,
    no_data: error_nodata,
    error: error_misc,
    api_base: '/api/'
};

/**********************************************
 HELPER FUNCTIONS
**********************************************/

// Default Parameter check and assign
var defPar = function(arg, def) {
    return typeof arg == 'undefined' ? def : arg;
};

/**********************************************
 PRIVATE FUNCTIONS
**********************************************/

function error_forbidden(t, m) {
    alert(t + '\n\n' + m);
}

function error_nodata(t, m) {
    alert(t + '\n\n' + m);
}

function error_misc(t, m) {
    alert(t + '\n\n' + m);
}

function call(type, url, data, parse, async) {
    parse = defPar(parse, true);
    async = defPar(async, true);

    return $.ajax({
        type: type,
        async: async,
        url: options.api_base + url,
        headers: headers,
        data: data
    })
        .fail(function(jqXHR, textStatus, errorThrown) {
            if (jqXHR.status == 403) {
                options.forbidden(
                    'Communication Error',
                    'Could not communicate with server please try to refresh the page.'
                );
            }
        })
        .pipe(function(json) {
            if (parse) {
                data = JSON.parse(json);

                if (data == null)
                    options.no_data(
                        'Communication Error',
                        'Recieved no data from server.'
                    );
                else if (!data.success)
                    options.error(data.error.title, data.error.msg);
                return data;
            } else return json;
        });
}

/**********************************************
 PUBLIC FUNCTIONS
**********************************************/

// define some options for all api calls
self.set_options = function(params) {
    // assign to object and default items if needed
    options = utils.merge_options(default_args, params);
};

// define a header to be part of all api calls
self.set_header = function(header_name, header_value) {
    headers[header_name] = header_value;
};

// remove a header
self.remove_header = function(header_name) {
    if (headers[header_name]) delete headers[header_name];
};

// get default page data
self.default_page = function() {
    return call('GET', 'default', null);
};

// get list of communities
self.community_list = function() {
    return call('GET', 'comm', null);
};

// get landing page data
self.landing_page = function(id) {
    return call('GET', 'comm/' + id, null);
};

// get unit list and possibly lp data
self.unit_direct = function(id, lp) {
    return call('GET', 'comm/' + id + '/unit/' + lp, null);
};

// get unit data for configurator
self.unit = function(id) {
    return call('GET', 'chk/unit/' + id, null);
};

// get user data for unit if any
self.get_user_data = function(res_id, unit_id) {
    return call('GET', 'chk/unit/' + unit_id + '/user/' + res_id, null);
};

// save user data
self.save_user_data = function(data) {
    return call(
        'PUT',
        'chk/unit/' + data.unit_id + '/user/' + data.user_id,
        data.user_config
    );
};

// create new user
self.create_user = function(data) {
    return call('POST', 'auth/user', data);
};

// request export
self.request_export = function(data) {
    return call(
        'PUT',
        'chk/unit/' + data.unit_id + '/user/' + data.id + '/export',
        data
    );
};

/**********************************************
 MODULE EXPORT
**********************************************/
module.exports = self;
